// TODO: move to station
import { List } from 'immutable';

import { type IListOf } from 'src/types';

import * as Constants from '../constants';
import { Map } from '../lib/ImmutableUtils';
import { createReducer } from '../lib/ReducerUtils';

const INITIAL_STATE = Map({
  [Constants.Narratives.STATION_NARRATIVE_IS_SHOWN]: false,
  [Constants.Narratives.STATION_NARRATIVES_HIDDEN]: List() as IListOf<$TSFixMe>,
});
export type StationNarrativeState = typeof INITIAL_STATE;

// STATIONNARRATIVE REDUCER
export default createReducer(INITIAL_STATE, {
  [Constants.Playback.ActionTypes.IS_STATION_NARRATIVE_DISPLAYED]: isStationNarrativeDisplayed,
});

// CASE FUNCTIONS

function isStationNarrativeDisplayed(
  state: StationNarrativeState,
  action: $TSFixMe,
): StationNarrativeState {
  if (action.data.stationId) {
    return state.merge({
      [Constants.Narratives.STATION_NARRATIVE_IS_SHOWN]: action.data.doShow,
      [Constants.Narratives.STATION_NARRATIVES_HIDDEN]: state
        .get(Constants.Narratives.STATION_NARRATIVES_HIDDEN)
        .concat(action.data.stationId),
    });
  }
  return state.set(Constants.Narratives.STATION_NARRATIVE_IS_SHOWN, action.data.doShow);
}
